module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_1.fd4b0ce9.png";